module.exports = __webpack_public_path__ + "img/courses6.4202b48b.jpg";